export default "__VITE_ASSET__e23073b0__"